// extracted by mini-css-extract-plugin
module.exports = {"adblock":"AdBlock_adblock__OAHuX","adblock__placeholder":"AdBlock_adblock__placeholder__iWmt2","ads-loading":"AdBlock_ads-loading__CnGTU"};